import {AbstractViewerComponent} from "./abstract-viewer.component";
import {customElement} from "lit/decorators/custom-element.js";
import {DateHelper} from "../../helpers/date.helper";
import {PropertyValues} from "@lit/reactive-element";
import {DateTime} from "luxon";
import {nothing} from "lit";

@customElement('ha-date-viewer')
export class HaDateViewerComponent extends AbstractViewerComponent<string, {
    preRender: (value: DateTime) => DateTime
}> {

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return typeof this.value == "string" && super.shouldUpdate(_changedProperties);
    }

    protected render(): unknown {
        if (!this.value) {
            return nothing;
        }

        let value: DateTime = DateTime.fromISO(this.value as string, {zone: 'utc'});
        value = this.settings?.preRender?.(value) ?? value as DateTime;

        return DateHelper.fromDateTimeToDateString(value);
    }
}